export const statusesData = {
    texts: {
        "win": "You won!",
        "lose": "You lost...",
        "draw": "Draw"   
    },
    colors: {
        "win": "green",
        "lose": "red",
        "draw": "yellow"
    }
}